import classNames from 'classnames';

import Modal from '~/shared/components/modal/modal';
import { useTypedTranslation } from '~/shared/hooks';
import type { changeStateOfConfirmModal } from '~/shared/store/slices/app/app-slice';

import '~/shared/components/confirm-removing-modal/confirm-removing-modal.scss';

type ConfirmRemovingModalPayload = Parameters<typeof changeStateOfConfirmModal>[0];

type ConfirmRemovingModalPropsType = Readonly<{
  isModalOpen: boolean;
  itemKey: string | null;
  isDisabledSubmitButton?: boolean;
  zIndex?: number;
  isFullScreen?: boolean;
  isNoFooter?: boolean;
  isNoTitle?: boolean;
  isRemoving?: boolean;
  onCancel?: (() => void) | null;
  title?: string | null;
  message?: string | null;
  wrapClassName?: string | null;
  onTrigger?: ((itemKey: string | null) => void | Promise<void>) | null;
  changeStateOfModal: (payload: ConfirmRemovingModalPayload) => void;
}>;

const ConfirmRemovingModal = ({
  isModalOpen,
  changeStateOfModal,
  isDisabledSubmitButton = false,
  zIndex = 15000,
  isNoTitle = false,
  isNoFooter = false,
  isFullScreen = false,
  isRemoving = false,
  onCancel = null,
  wrapClassName = null,
  title,
  message,
  itemKey,
  onTrigger,
}: ConfirmRemovingModalPropsType) => {
  const t = useTypedTranslation(['modal', 'button']);
  const isCalendarFullscreenModal =
    wrapClassName?.split(/\s+/).includes('calendar-fullscreen-modal') ?? false;

  return (
    <Modal
      isModalOpen={isModalOpen}
      zIndex={zIndex}
      withNoFooter={isNoFooter}
      wrapClassName={classNames('confirm-removing-modal-wrap', wrapClassName)}
      onCancel={onCancel ?? undefined}
      isDisabledSubmitButton={isDisabledSubmitButton}
      submitButtonClassName="call-to-action-button--purple"
      width={500}
      headerTitle={isNoTitle ? null : (title ?? t('modal.confirm.title'))}
      changeStateOfModal={() =>
        changeStateOfModal({
          onTrigger: null,
          title: '',
          message: '',
          isShowed: false,
          isRemoving: false,
          itemKey: null,
          isDisabledSubmitButton: false,
        })
      }
      submitText={t(isRemoving ? 'button.remove' : 'button.ok')}
      cancelText={t('button.cancel')}
      onSubmit={() => onTrigger?.(itemKey)}
      isFullScreen={isFullScreen}
      fullScreenInset={isCalendarFullscreenModal ? 8 : undefined}
      withScrollBars
    >
      <div
        className={classNames('confirm-removing-modal', {
          'confirm-removing-modal--fullscreen': isFullScreen,
        })}
      >
        <div className="confirm-removing-modal__message">{message ?? t('modal.confirm.message')}</div>
      </div>
    </Modal>
  );
};

export default ConfirmRemovingModal;
